<template>
  <div>
    <button
      v-on:click.stop="toggleAccordion()"
      class="flex flex-col justify-between items-center rounded p-2 text-neutral-0"
      :class="{ 'bg-primary-800': isOpen, 'bg-neutral-400': !isOpen }"
    >
      <span class="flex flex-col justify-between w-8 flex-1 text-sm font-bold">
        <span>{{ scheduleGroupName }}</span>
        <font-awesome-icon
          v-if="isOpen"
          :icon="['fas', 'minus']"
        ></font-awesome-icon>
        <font-awesome-icon v-else :icon="['fas', 'plus']"></font-awesome-icon>
      </span>
    </button>

    <div v-show="isOpen" class="flex flex-row gap-4 flex-1">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

const isOpen = ref(true);

function toggleAccordion() {
  isOpen.value = !isOpen.value;
}

defineProps({
  scheduleGroupName: {
    type: String,
    required: true,
  },
});
</script>
